module.exports = __webpack_public_path__ + "media/images/front/review_star_00-513cea70910b9707dbc5c693e1d42afc.png";